module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/NEW_PRODUCTS.bff5308c.svg";